module Visonum.BulkPingApp.App.Login
  ( view
  ) where

import Visonum.BulkPingApp.Prelude (AppHTML, inline, styleLeaf, styleNode, text)

import Data.Maybe (Maybe(..))
import Halogen.HTML.Elements as H
import Halogen.HTML.Properties as HP
import Visonum.BulkPingApp.Components.App.Types (Action(..), LogInState(..), State)
import Visonum.BulkPingApp.Imgs (imgVfLogo)
import Visonum.BulkPingApp.Views.PrimaryButton as PrimaryButton
import Visonum.BulkPingApp.Views.TextInput as TextInput

view :: forall slots. State -> AppHTML slots Action
view state =
  let
    elRoot = styleNode H.div
      "Login"
      [ inline
          { display: "flex"
          , flexDirection: "column"
          , alignItems: "center"
          , justifyContent: "center"
          , height: "100%"
          , gap: "20px"
          , position: "relative"
          }
      ]

  in
    elRoot
      []
      [ case state.logInState of
          LoginChecking -> viewChecking
          LoginNotTried -> viewLogin state
          LoginSuccess -> viewLogin state
          LoginFailure -> viewFailure
      ]

viewChecking :: forall w. AppHTML w Action
viewChecking =
  let
    elRoot = styleNode H.div
      "Checking"
      [ inline
          { display: "flex"
          , flexDirection: "column"
          , alignItems: "center"
          , justifyContent: "center"
          , height: "100%"
          , gap: "20px"
          , fontSize: "20px"
          , fontFamily: "Arial"
          }
      ]
  in
    elRoot
      []
      [ text "Loggin in..." ]

viewFailure :: forall w. AppHTML w Action
viewFailure =
  let
    elRoot = styleNode H.div
      "Checking"
      [ inline
          { display: "flex"
          , flexDirection: "column"
          , alignItems: "center"
          , justifyContent: "center"
          , height: "100%"
          , gap: "20px"
          , fontSize: "20px"
          , fontFamily: "Arial"
          }
      ]

    elTryAgain = styleNode H.div
      "TryAgain"
      [ inline
          {
          }
      ]
  in
    elRoot
      []
      [ text "Login failed"
      , elTryAgain
          []
          [ PrimaryButton.view
              { label: "Try again"
              , onClick: Logout
              , disabled: false
              }
          ]
      ]

viewLogin :: forall w. State -> AppHTML w Action
viewLogin state =
  let
    elRoot = styleNode H.div
      "Login"
      [ inline
          { display: "flex"
          , flexDirection: "column"
          , alignItems: "center"
          , justifyContent: "center"
          , height: "100%"
          , gap: "20px"
          }
      ]

    elInput = styleNode H.div
      "Input"
      []

    elButton = styleNode H.div
      "Button"
      []
  in
    elRoot
      []
      [ elInput
          []
          [ TextInput.view
              TextInput.defaultProps
                { label = ""
                , value = state.spmApiKey
                , onChange = SetPassword
                , onEnter = Just Login
                , password = true
                }
          ]
      , elButton []
          [ PrimaryButton.view
              { label: "Login"
              , onClick: Login
              , disabled: false
              }
          ]
      ]
